import { Stack } from '@mui/material';
import { FormTextField } from 'src/components/Forms';
import { ClientSegmentFormField } from './client-segment-form.types';

interface ClientSegmentFormFieldsProps {
  disabled?: boolean;
}

const SEGMENT_NAME_HELPER = 'Internal label. Visible only to your team.';
const DISPLAY_NAME_HELPER = 'What customers see in receipts, plan names, and outbound emails.';

export const ClientSegmentFormFields = ({ disabled }: ClientSegmentFormFieldsProps) => (
  <Stack spacing={2}>
    <FormTextField
      type="textfield"
      name={ClientSegmentFormField.Name}
      label="Segment name"
      required="Segment name is required"
      disabled={disabled}
      showErrorText
      textFieldProps={{
        variant: 'outlined',
        helperText: SEGMENT_NAME_HELPER,
      }}
    />
    <FormTextField
      type="textfield"
      name={ClientSegmentFormField.DisplayName}
      label="Display name"
      required="Display name is required"
      disabled={disabled}
      showErrorText
      textFieldProps={{
        variant: 'outlined',
        helperText: DISPLAY_NAME_HELPER,
      }}
    />
  </Stack>
);
